import React, { Component } from "react";
import { ajaxManage, setTokenById } from "utils/common";
import { Form, Icon, Input, Button, message } from 'antd';
import "./index.less";
//图片
import Logo from "images/logo.png";

class App extends Component {

  	handleSubmit = (e) => {
    	e.preventDefault();
    	this.props.form.validateFields((err, values) => {
      		if (!err) {
        		console.log('Received values of form: ', values);
        		ajaxManage({
        			url: "/sys/login",
        			data: values
        		}).then(res => {
					setTokenById("admin", res.data);
                    message.destroy();
        			message.success('登录成功！', () => {
        				this.props.history.replace("/console/list");
        			});
        		}).catch(err => {
                    message.destroy();
        			message.error('用户名或密码错误！');
        		})
      		}
    	});
  	}

  	render() {
    	const { getFieldDecorator } = this.props.form;

    	return (
    		<div className="login-wrap">
    			<div className="login-main">
	    			{/*<img src={Logo} className="login-logo" />*/}
	    			<h1 className="login-title">大易视频管理系统</h1>
	    			<Form onSubmit={this.handleSubmit} className="login-form">
				        <Form.Item>
				          	{getFieldDecorator('userName', {
						        rules: [{ required: true, message: '请输入用户名！' }]
						    })(
						        <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder = "用户名" />
							)}
				        </Form.Item>
				        <Form.Item>
				          	{getFieldDecorator('password', {
				            	rules: [{ required: true, message: '请输入密码！' }]
				          	})(
				            	<Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="密码" />
				          	)}
				        </Form.Item>
				        <Form.Item className="login-btn-wrap">
			          		<Button type="primary" htmlType="submit">登录</Button>
				        </Form.Item>
			      	</Form>
    			</div>
    		</div>
		);
	}
}

const WrappedNormalLoginForm = Form.create({ name: 'normal_login' })(App);

export default WrappedNormalLoginForm;